<template>
    <div
        :class="{
            conversions: true,
            'padded-page': true,
            gray: !above0TotalCoversion,
        }"
        ref="screenWrapper"
    >
        <template v-if="above0TotalCoversion">
            <p>In 2025, you held a total of</p>
            <div class="grid grid-cols-2 gap-4 my-4">
                <div class="bg-yInRev-light-blue text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                    {{ $format.renderCurrency(reviewData?.total_usd, "compact", "USD") }}
                </div>
                <div class="bg-yInRev-light-blue text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                    {{ $format.renderCurrency(reviewData?.total_gbp, "compact", "GBP") }}
                </div>
                <div class="bg-yInRev-light-blue text-white font-satoshi_b px-4 py-3 rounded-xl text-2xl">
                    {{ $format.renderCurrency(reviewData?.total_eur, "compact", "EUR") }}
                </div>
            </div>
            <p v-if="above10KTotalCoversion" class="mb-3">
                Your most frequent conversion was
                <span class="font-satoshi_b text-yInRev-light-blue">{{ swapPair[0] }}</span> to
                <span class="font-satoshi_b text-yInRev-light-blue">{{ swapPair[1] }}</span
                >, a total of <span class="font-satoshi_b text-yInRev-light-blue">{{ reviewData?.currency_conversion_count }} times</span>.
            </p>
            <p v-else class="mb-3">You held less than 10 USD/GBP/EUR in 2025. The more you hold, the more you get to hedge against inflation.</p>
        </template>
        <template v-else>
            <p class="mb-3">You didn’t swap currencies 😞.</p>
            <p class="mb-20 sm-h:mb-8">
                Seamlessly switch between
                <span class="font-satoshi_b text-yInRev-light-blue">NGN, USD, GBP</span> &
                <span class="font-satoshi_b text-yInRev-light-blue">EUR </span>
                —real-time, competitive rates, all on the Sycamore app.
            </p>
        </template>
        <img
            src="../../assets/images/year-in-review/conversions-stamp.svg"
            alt="conversions-stamp"
            :class="{
                'mx-auto': true,
                grayscale: !above0TotalCoversion,
            }"
        />
    </div>
</template>

<script>
import CountUpNumber from "./CountUp.vue";

export default {
    components: {
        CountUpNumber,
    },

    props: {
        reviewData: Object,
    },

    computed: {
        above10KTotalCoversion() {
            return (this.reviewData?.total_usd ?? 0) > 10 || (this.reviewData?.total_gbp ?? 0) > 10 || (this.reviewData?.total_eur ?? 0) > 10;
        },
        above0TotalCoversion() {
            return this.reviewData?.total_converted_value > 0;
        },
        swapPair() {
            return this.reviewData?.top_currency_pair?.split(" → ");
        },
    },

    mounted() {
        const screenWrapper = this.$refs.screenWrapper;
        const hammer = new Hammer(screenWrapper);

        hammer.on("tap", () => {
            if (this.currentScreen === 0) return;
            this.$emit("goForward");
        });
    },
};
</script>

<style scoped>
.conversions {
    color: #ffffff;
    background-color: #073042;
    background-image: url("../../assets/images/year-in-review/conversions.svg");
    background-repeat: no-repeat;
    background-attachment: fixed;
    background-position: bottom right;
    min-height: 100vh;
}

.conversions.gray {
    background-image: url("../../assets/images/year-in-review/conversions-low.svg");
}

@media (max-height: 750px) {
    .conversions {
        background-size: 55% auto !important;
    }
}
</style>
